import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/water-effects.css';
import App from './App';

// Build version: 2025-12-08-v2

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
